<template>
  <div :id="id" aria-live="assertive">
    <span
      v-if="message"
      v-text="message"
      :class="{ 'comet-screenreader-only': !isVisible }"
    ></span>
    <span
      v-else
      v-html="'&nbsp;'"
      :class="{ 'comet-screenreader-only': !isVisible }"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'AriaLiveRegion',
  props: {
    id: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
